/** legend-with-dropdown */

<template>
    <div class="legend-item-with-dropdown">
        <div>
            <label>
                <input type="checkbox" class="legend-checkbox" v-model="checkboxState"/> {{ layer.group_name }}
            </label>
        </div>

        <div class="dropdown-item-below-title" v-if="checkboxState">
            <div>
                <img alt="Fishing activity legend" v-bind:src="layer.local_legend_ref" v-if="layer.local_legend_ref">
            </div>

            <div>
                <select v-model="selectorState">
                    <option v-for="sublayer in layer.layers" v-bind:value="sublayer.layer_name">
                        {{ sublayer.layer_name_display }}
                    </option>
                </select>
            </div>

        </div>
    </div>
</template>


<script>
import store from "../store/reality-check-store";


export default {
    name: "legend-with-dropdown",
    components: {},
    store,
    props: {
        layer: {type: Object, required: true},
    },
    data: function () {
        return {
            checkboxState: false,
            selectorState: null
        }
    },
    methods: {
        emitStateChange: function () {
            // returns a list of layers to show and hide - a cheat to facilitate a simple data structure in the store
            if (this.checkboxState) {
                this.$emit("layer-change", ["dropdown-group",
                    this.selectorState,
                    this.layerNames.filter(layer_name => layer_name !== this.selectorState)])

            } else {
                // off, clear all layers
                this.$emit("layer-change", ["dropdown-group", null, this.layerNames])
            }

        }
    },
    computed: {
        layerNames: function () {
            return Object.keys(this.layer.layers)
        }
    },
    watch: {},
    mounted: function () {
        this.checkboxState = this.layer.start_enabled;
        // this is a bit gross, but sets the dropdown to the first value in the object (not truly supported by ecmascript, but browsers currently respect it)
        this.selectorState = this.layer.layers[Object.keys(this.layer.layers)[0]].layer_name;

        // add watchers here to avoid firing on initial setup - https://stackoverflow.com/a/58949762/
        this.$watch("checkboxState", this.emitStateChange);
        this.$watch("selectorState", this.emitStateChange);
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    .legend-item-with-dropdown {
        margin-bottom: 5px;

        > div {
            width: 100%;
            display: inline-block;

            input[type=checkbox] {
                margin-right: 2px;
            }
        }

        .dropdown-item-below-title {
            margin-top: 5px;
            display: flex;
            justify-content: flex-start;

            > div:first-of-type {
                display: flex;
                flex: 0 0 58px;
                margin: 0 10px 0 20px;
            }

            > div:nth-of-type(2) {
                display: flex;
                align-items: center;

                select {
                    font-size: 90%;
                    padding: 1px;
                }
            }
        }
    }
</style>